<script lang="ts">
  import { onMount } from 'svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';
  import { withPageTitle } from '../../lib/page-title';
  import { bootAuth } from '../../lib/stores/auth';

  // /donate/thanks — post-checkout landing.
  //
  // Stripe redirects here with ?session_id=cs_... but we don't need to
  // verify anything client-side — the webhook records the donation and
  // syncs the donor tier. We just say thanks and re-fetch /api/auth/me
  // after a short delay so the donor badge appears without a manual
  // reload.

  $effect(() => withPageTitle('Thanks'));

  onMount(() => {
    // Webhooks usually fire within a couple seconds of the checkout
    // completing; 2s is enough headroom in practice. If the badge still
    // isn't there, the user hitting the home link triggers a fresh load
    // anyway. We don't poll — the eventually-consistent path is fine.
    const t = setTimeout(() => {
      void bootAuth();
    }, 2000);
    return () => clearTimeout(t);
  });
</script>

<article class="donate-thanks">
  <Card padding="lg" elevated>
    <h1 class="donate-thanks__title">Thanks &mdash; you&rsquo;re a star.</h1>
    <p class="donate-thanks__body">
      Your donation is being processed by Stripe. The donor badge will
      show next to your username within a minute. A receipt is on its
      way to your email.
    </p>
    <div class="donate-thanks__actions">
      <Button variant="primary" href="/">Back to the globe</Button>
      <Button variant="ghost" href="/account">Account</Button>
    </div>
  </Card>
</article>
